export { businessQuotesService, BusinessQuotesService } from './business';
export {
  capitalGlobalQuotesService,
  CapitalGlobalQuotesService,
} from './capital-global';
export { quoteActivitiesService, QuoteActivitiesService } from './activities';
export type {
  ListQuoteActivitiesResponse,
  QuoteActivity,
  QuoteActivityChange,
} from './activities';
export { commonQuotesService, CommonQuotesService } from './common';
export { homeownerQuotesService, HomeownerQuotesService } from './homeowner';
export {
  rdEquipamentosService,
  RdEquipamentosService,
} from './rd-equipamentos';
export * from './types';

export type { CreateQuotePayload, Product } from './types';

import { commonQuotesService } from './common';
import type { SendProposalEmailPayload } from './types';

/**
 * Fachada do módulo de cotações. Expõe uma API única para os callers
 * do frontend. O envio de e-mail é unificado no endpoint comum
 * `/portal/v1/quotes/send-email`, que aceita qualquer produto.
 */
export class QuotesService {
  async sendProposalEmail(payload: SendProposalEmailPayload): Promise<{
    success: boolean;
    error?: string;
    message?: string;
  }> {
    return commonQuotesService.sendProposalEmail(payload);
  }
}

export const quotesService = new QuotesService();
